import { useEffect, useState } from 'react'

export const WAIT_SCREEN_DELAY_MS = 1000

export function useHasWaitedLong(isWaiting: boolean) {
  const [hasWaitedLong, setHasWaitedLong] = useState(false)

  useEffect(() => {
    if (!isWaiting) {
      setHasWaitedLong(false)
      return undefined
    }
    const timer = setTimeout(() => setHasWaitedLong(true), WAIT_SCREEN_DELAY_MS)
    return () => clearTimeout(timer)
  }, [isWaiting])

  return { hasWaitedLong: isWaiting && hasWaitedLong }
}



// WEBPACK FOOTER //
// ./src/pages/OAuthConnect/useHasWaitedLong.ts